import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const Main = styled.div`
   position: relative;
   box-sizing: border-box;
   padding: 0 !important;
   width: min(580px, calc(100vw - 32px));
   max-height: min(82vh, 720px);
   border-radius: 18px !important;
   background: rgba(251, 250, 254, 0.98);
   border: 1px solid ${theme.colors.border};
   box-shadow:
      0 1px 0 rgba(255, 255, 255, 0.65) inset,
      0 24px 60px -20px rgba(29, 20, 70, 0.42) !important;
   display: flex;
   flex-direction: column;
   overflow: hidden;

   .panel-head {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      padding: 18px 18px 14px;
      border-bottom: 1px solid ${theme.colors.border};
      background: linear-gradient(180deg, rgba(237, 235, 250, 0.65), rgba(251, 250, 254, 0.2));
      flex-shrink: 0;

      .icon {
         width: 40px;
         height: 40px;
         border-radius: 12px;
         display: grid;
         place-items: center;
         background: ${theme.gradients.primary};
         color: #fff;
         box-shadow: 0 8px 18px -10px rgba(79, 63, 224, 0.65);
         flex-shrink: 0;
      }

      .copy {
         flex: 1;
         min-width: 0;

         h3 {
            margin: 0 0 3px;
            font-size: 17px;
            font-weight: 700;
            color: ${theme.colors.text};
            letter-spacing: -0.015em;
         }

         p {
            margin: 0;
            font-size: 12.5px;
            line-height: 1.45;
            color: ${theme.colors.textSecondary};
         }
      }
   }

   .close {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 32px;
      height: 32px;
      border: 0;
      border-radius: 9px;
      background: transparent;
      color: ${theme.colors.textSecondary};
      display: grid;
      place-items: center;
      cursor: pointer;
      transition: background 0.15s ease, color 0.15s ease;

      &:hover {
         background: rgba(23, 18, 38, 0.06);
         color: ${theme.colors.text};
      }
   }

   .content {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      padding: 0 18px 18px;

      .tip {
         margin: 14px 0 16px;
         font-size: 12.5px;
         line-height: 1.5;
         background: rgba(237, 235, 250, 0.75);
         border: 1px solid ${theme.colors.border};
         color: ${theme.colors.textSecondary};
         border-radius: 12px;
         padding: 12px 14px;
         flex-shrink: 0;
      }

      .list {
         flex: 1;
         min-height: 0;
         overflow-y: auto;
         padding-right: 4px;
         margin-bottom: 14px;

         scrollbar-width: thin;
         scrollbar-color: rgba(107, 101, 132, 0.3) transparent;

         &::-webkit-scrollbar { width: 6px; }
         &::-webkit-scrollbar-thumb {
            background: rgba(107, 101, 132, 0.28);
            border-radius: 999px;
         }

         .item {
            margin-bottom: 12px;
            padding: 14px;
            border-radius: 14px;
            border: 1px solid ${theme.colors.border};
            background: #fff;
            box-shadow: 0 4px 14px -12px rgba(29, 20, 70, 0.18);

            .label {
               font-size: 13.5px;
               font-weight: 700;
               margin-bottom: 10px;
               color: ${theme.colors.text};
            }

            .authSelect {
               margin-bottom: 0;

               button {
                  background: ${theme.gradients.primary} !important;
                  border-color: rgba(79, 63, 224, 0.35) !important;
                  box-shadow: 0 4px 12px -6px rgba(79, 63, 224, 0.45) !important;

                  &:hover:not(:disabled) {
                     background: linear-gradient(150deg, #9588FF, #5F51E8 75%) !important;
                     border-color: rgba(79, 63, 224, 0.5) !important;
                     box-shadow: 0 6px 16px -6px rgba(79, 63, 224, 0.55) !important;
                  }
               }
            }

            .spreadsheetGlobal {
               margin-top: 14px;
               padding: 14px;
               border: 1px solid ${theme.colors.border};
               border-radius: 12px;
               background: ${theme.colors.backgroundAlt};

               .subLabel {
                  font-size: 13px;
                  font-weight: 700;
                  margin-bottom: 4px;
                  color: ${theme.colors.text};
               }
               .subHint {
                  font-size: 11.5px;
                  line-height: 1.45;
                  color: ${theme.colors.textSecondary};
                  margin: 0 0 12px;
               }
               .spreadsheetActions {
                  display: flex;
                  gap: 8px;
                  margin-bottom: 12px;
                  flex-wrap: wrap;

                  button {
                     height: 34px;
                     gap: 6px;
                     padding: 0 12px;
                     border-radius: 10px;
                     font-size: 12px;
                     font-weight: 600;
                  }
                  .btnFetch {
                     color: ${theme.colors.primary};
                     border-color: rgba(79, 63, 224, 0.25);
                     background: rgba(237, 235, 250, 0.8);

                     &:hover:not(:disabled) { background: rgba(237, 235, 250, 1); }
                  }
                  .btnClear {
                     color: ${theme.colors.coral};
                     border-color: rgba(217, 87, 63, 0.25);
                     background: rgba(254, 242, 242, 0.8);
                  }
               }
               .documentField {
                  display: grid;
                  grid-template-columns: 110px minmax(0, 1fr);
                  align-items: center;
                  gap: 12px;

                  .documentLabel {
                     display: flex;
                     align-items: center;
                     gap: 6px;
                     color: ${theme.colors.textSecondary};
                     font-size: 12.5px;
                     font-weight: 600;
                  }
                  .select { margin: 0 !important; }
               }
            }
         }
      }

      .empty {
         text-align: center;
         padding: 36px 16px;
         color: ${theme.colors.textSecondary};
         font-size: 14px;
         margin-bottom: 12px;
         border: 1.5px dashed ${theme.colors.border};
         border-radius: 14px;
         background: rgba(255, 255, 255, 0.6);
      }

      .action {
         display: flex;
         justify-content: flex-end;
         gap: 8px;
         flex-shrink: 0;
         padding-top: 4px;

         button {
            border: 0;
            border-radius: 11px;
            padding: 10px 18px;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
            background: ${theme.surface.hoverFill};
            color: ${theme.colors.textSecondary};
            transition: background 0.15s ease, color 0.15s ease;

            &:hover {
               background: ${theme.colors.border};
               color: ${theme.colors.text};
            }
         }
      }
   }

   @media (max-width: 600px) {
      width: calc(100vw - 24px);

      .content .list .item .spreadsheetGlobal .documentField {
         grid-template-columns: 1fr;
         gap: 7px;
      }
   }
`;
